import { IonButton, IonIcon } from '@ionic/react';
import { sparkles } from 'ionicons/icons';
import { ReactElement } from 'react';
import { getLocalizedText } from '../../../../../../../i18n/i18n.utils';
import './weld-recommendations-header-button.css';

interface WeldRecommendationsHeaderButtonProps {
  onClick: () => void;
  isLoading?: boolean;
}

export const WeldRecommendationsHeaderButton = ({
  onClick,
  isLoading = false,
}: WeldRecommendationsHeaderButtonProps): ReactElement => {
  // Always show the button - let users discover AI recommendations

  return (
    <div className="recommendations-header-button">
      <IonButton
        fill="clear"
        size="small"
        className="recommendations-action-button"
        onClick={onClick}
        id="recommendations-trigger-button"
      >
        <IonIcon icon={sparkles} slot="start" />
        {isLoading
          ? getLocalizedText('common:thinking')
          : getLocalizedText('welding:ai_suggestions')}
      </IonButton>
    </div>
  );
};
